import { CUSTOM_ELEMENTS_SCHEMA, Component, computed, input, output } from '@angular/core';
import { TIPO_PLANO_LABEL, TipoPlano } from '../../../../core/enum/parametros/tipo-plano.enum';
import { PlanoResumo } from '../../../../core/models/parametros/plano.model';
import { formatDateIsoToBr } from '../../../../core/utils/date-format.util';
import { TrilhaNavegacaoComponent } from '../../trilha-navegacao/trilha-navegacao.component';

/**
 * Cabeçalho da parametrização do plano: trilha de navegação, nome e status do plano, dados
 * resumidos (código, tipo e última atualização) e o botão "Voltar para a lista".
 */
@Component({
  selector: 'app-plano-cabecalho',
  standalone: true,
  imports: [TrilhaNavegacaoComponent],
  // Web components do design system Vivest (`vivest-tag`, `vivest-button`, `vivest-icon`).
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './plano-cabecalho.component.html',
  styleUrl: './plano-cabecalho.component.scss',
})
export class PlanoCabecalhoComponent {
  readonly plano = input.required<PlanoResumo>();
  /** Texto do botão de voltar; a configuração de um instituto usa só "Voltar". */
  readonly rotuloVoltar = input('Voltar para a lista');

  /** Clique no botão de voltar; quem usa o cabeçalho decide para onde navegar. */
  readonly voltar = output<void>();

  /** Rótulo do tipo ("Contribuição Definida (CD)"); sigla desconhecida aparece como veio. */
  readonly tipo = computed(() => {
    const tipo = this.plano().tipo;
    return TIPO_PLANO_LABEL[tipo as TipoPlano] ?? (tipo || 'Não informado');
  });

  readonly passos = computed(() => ['Planos', 'Parâmetros de Plano', this.plano().nome]);
  readonly varianteStatus = computed(() => (this.plano().status === 'Ativo' ? 'success' : 'warning'));
  readonly ultimaAtualizacao = computed(() => formatDateIsoToBr(this.plano().ultimaAtualizacao));
}
